$(document).ready(function () {

    function sellingbuying() {

        var sellingBuying = $('input[name=SellingBuying]:checked').val();

        switch (sellingBuying) {

            case "1":
                $('.buyingRow').slideDown();
                $('.sellingRow').slideDown();
                mortgage();
                break;

            case "3":
                $('.buyingRow').slideDown();
                $('.sellingRow').slideUp();
                mortgage();
                break;

            case "2":
                $('.buyingRow').slideUp();
                $('.sellingRow').slideDown();
                $('.rowMortgage').slideUp();
                break;
        }
    }

    function old() {

        var old = $('input[name=OldUser]:checked').val();

        switch (old) {

            case "True":
                $('.rowAgent').slideDown();
                break;

            case "False":
                $('.rowAgent').slideUp();
                break;
        }
    }

    function mortgage() {

        var mortg = $('input[name=MortgageRequired]:checked').val();

        switch (mortg) {

            case "True":
                $('.rowMortgage').slideDown();
                break;

            case "False":
                $('.rowMortgage').slideUp();
                break;
        }
    }

    old();
    sellingbuying();    

    $("[name='SellingBuying']").on('change', function () {
        sellingbuying();
    });

    $("[name='OldUser']").on('change', function () {
        old();
    });

    $("[name='MortgageRequired']").on('change', function () {
        mortgage();
    });
});